import { CustomerSettingType } from '@/services/enums';
import { Dispatch, SetStateAction, useState } from 'react';
import { customerSettingsApiArea } from '@/services/api/customerSettingsApiArea';
import { RoomsRole, RoomsRoleAccess } from '@/services/api/customerSettingsApiArea/types';

type Return = [boolean, () => void, RoomsRole[], Dispatch<SetStateAction<RoomsRole[]>>];

interface Args {
  onClose: () => void;
  onSuccess: () => Promise<void>;
  customerId?: number;
  settings?: RoomsRoleAccess;
}

export const useRolesSettings = (args: Args): Return => {
  const { onClose, onSuccess, customerId, settings } = args;
  const [isLoading, setIsLoading] = useState(false);
  const Rules = settings?.Roles ? [...settings.Roles] : [];

  const [Roles, setRoles] = useState<RoomsRole[]>(Rules);

  const handleSubmit = () => {
    if (!customerId) return;

    setIsLoading(true);
    const temp: RoomsRoleAccess = {
      IsDisabled: true,
      Roles: settings?.Roles || []
    };

    customerSettingsApiArea()
      .SaveCustomerSettings({
        CustomerId: customerId,
        Type: CustomerSettingType.RoomsAccess,
        Settings: {
          RoomsRoleAccess: {
            ...temp,
            Roles
          }
        }
      })
      .then(onClose)
      .then(onSuccess)
      .finally(() => setIsLoading(false));
  };

  return [isLoading, handleSubmit, Roles, setRoles];
};
